export const translationEngDefault = {
  SkhemataFaqSearch: {
    "searchPlaceholder": "Enter Search Keyword...",
  }
};